import { Session } from '../../../../api/api-user';


export function checkGrants (username) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { auth } = getState();
      // Dispatch action that session is being requested.
      // Sessions call
      Session.checkGrants(username, auth.accessToken, (res) => {
        if (400 < res.statusCode || res.error) {
          return reject(res);
        }
        resolve(res);
      });
    });
  };
}

export function createSession (username, password) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // Dispatch action that session is being requested.
      dispatch({ type: 'SESSION_CREATE_REQUEST' });
      Session.create(username, password, (res) => {
        if (400 < res.statusCode || res.error) {
          dispatch({ type: 'SESSION_CREATE_FAILURE' });
          return reject(res);
        }
        dispatch({ type: 'SESSION_CREATE_SUCCESS' });
        return resolve(res);
      });
    });
  };
}
